<template>
    <div id="content-galery">
        <a-carousel arrows>
            <div 
                slot="prevArrow" 
                class="custom-slick-arrow" 
                style="left: 1vw;zIndex: 1"
                v-if="ruta1 != '' && ruta2 != ''"
            >
                <a-icon type="left-circle" />
            </div>
            <div 
                slot="nextArrow" 
                class="custom-slick-arrow" 
                style="right: 1vw;zIndex: 1"
                v-if="ruta1 != '' && ruta2 != ''"
            >
                <a-icon type="right-circle" />
            </div>
            <div 
                v-if="ruta1 != ''" 
                class="cont-img"
            >
                <img 
                    class="img" 
                    :src="ruta1" 
                    @error="Replace_Image"
                >
            </div>
            <div 
                v-if="ruta2 != ''" 
                class="cont-img"
            >
                <img 
                    class="img" 
                    :src="ruta2" 
                    @error="Replace_Image"
                >
            </div>
        </a-carousel>
    </div>
</template>

<script>
    export default {
        name: 'Galery',

        data(){
            return{
                imgError: require('@/assets/images/imagen_no_disponible.png')
            }
        },

        props:{
            ruta1: String,
            ruta2: String
        },

        methods: {
            /*
            * En caso de que la ruta para consultar la imagen no esté disponible
            * Reemplaza la imagen por una por defecto
            */
            Replace_Image(e) {
                e.target.src = this.imgError;
            }
        }
    };
</script>

<style scoped>

#content-galery{
    margin: 1em;
}

.cont-img{
    height: 30em;
}

.img{
    margin: 0 auto;
    height: 100%;
}

.ant-carousel >>> .slick-slide {
    display: flex;
    justify-content: center;
    padding: 1em;
    background: rgba(30, 30, 30, 0.7);
}

.ant-carousel >>> .custom-slick-arrow {
    margin-right: .3em;
    font-size: 1.8em;
    color: rgba(184, 178, 178, 0.9);
}
.ant-carousel >>> .custom-slick-arrow:before {
    display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
    color: rgba(184, 178, 178, 0.7);
    opacity: 0.5;
}

</style>